import css from "./Loader.module.css";

export function Loader() {
  return <div className={css.root}>
    <div className={css.spinner}></div>
    <div className={css.placeholder}></div>
  </div>;
}